import { Component, Input } from '@angular/core';
import { CampaignService } from '../../../../services/campaign/campaign.service';
import { CampaignStep } from '../campaign-step';
import { Campaign } from '../campaign';


@Component({
  selector: 'campaign-step-1',
  templateUrl: 'campaign-step-1.html',
})
export class CampaignStep1Component implements CampaignStep {

  @Input() campaign: Campaign;

  public goals: Object[] = [];
  private goalIcons: string[] = ['fa fa-users', 'fa fa-map-marker', 'fa fa-shopping-bag'];


  constructor(private campaignService: CampaignService) {

  }

  ngOnInit()
  {
    if (this.campaign.name) {
      this.campaign.name = undefined;
      this.campaign.goalId = 1;
      this.campaign.targetId = null;
      this.campaign.getCreateCampaignFormData = undefined;
      this.campaign.emissionStartDate = null;
      this.campaign.emissionEndDate = null;
      this.campaign.redemptionStartDate = null;
      this.campaign.redemptionEndDate = null;
      this.campaign.budget = 0;
      this.campaign.stores = [];
      this.campaign.storesId = [];
      this.campaign.coupons = [];
    }

    if(typeof this.campaign.getCreateCampaignFormData !== 'undefined') {
      this.loadFormData();
      return;
    }

    this.campaignService.getCreateCampaignFormData().subscribe(res => {
      this.campaign.getCreateCampaignFormData = res;
      this.loadFormData();
    });

  }

  loadFormData()
  {
    const res = this.campaign.getCreateCampaignFormData;

    for(let i in res.campaignGoalModel) {
      if(typeof this.campaign.goalId === 'undefined') {
        this.campaign.goalId = res.campaignGoalModel[i].focusId;
      }
      this.goals.push(res.campaignGoalModel[i]);
    }
  }

  setGoal(goalId)
  {
    this.campaign.goalId = goalId;
    this.campaign.targetId = undefined;
  }

  setTarget(targetCode)
  {
    this.campaign.targetId = targetCode;
    this.campaign.getCreateCampaignDefaultFormData = undefined;
  }

  public isStepCompleted()
  {
    return (
      typeof this.campaign.goalId !== 'undefined' &&
      typeof this.campaign.targetId !== 'undefined'
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/views/campaign/new-campaign/step-1/campaign-step-1.component.ts